import dealerApiClient from '../api/dealerApiClient'
import type { DealerProfile, DealerProfileUpdateRequest } from '../types'

export async function getProfile(): Promise<DealerProfile> {
  const { data } = await dealerApiClient.get<DealerProfile>('/profile')
  return data
}

// ошибки: PHONE_INVALID, VALIDATION_ERROR
export async function updateProfile(body: DealerProfileUpdateRequest): Promise<DealerProfile> {
  const { data } = await dealerApiClient.put<DealerProfile>('/profile', body)
  console.log('[INFO] Dealer profile updated')
  return data
}

// Логотип: PNG, JPEG или WebP до 1 МБ (ошибки LOGO_TOO_LARGE, LOGO_UNSUPPORTED_TYPE)
export async function uploadProfileLogo(file: File): Promise<DealerProfile> {
  const form = new FormData()
  form.append('file', file)
  // клиент по умолчанию шлёт JSON — без явного multipart axios сериализует FormData в JSON
  const { data } = await dealerApiClient.post<DealerProfile>('/profile/logo', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  console.log('[INFO] Dealer logo uploaded')
  return data
}

export async function deleteProfileLogo(): Promise<void> {
  await dealerApiClient.delete('/profile/logo')
  console.log('[INFO] Dealer logo deleted')
}
